import React from "react";
import { Navigate, useRoutes, useSearchParams } from "react-router-dom";

import { PerfilConsulta } from "./PerfilConsulta";
import { PerfilForm } from "./PerfilForm";
import { useVoltar } from "@/Contexts/NavegacaoContext";

import "@/Styles/Perfil.css"

type PerfilRouterProps = {}

export const PerfilRouter = (props: PerfilRouterProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const voltar = useVoltar(".");

    const routes = useRoutes([
        {
            path: "/",
            index: true,
            element: <PerfilConsulta hrefDoBotaoAdicionar="./cadastro" hrefDoBotaoEditar={(v) => "./editar?id=" + v.codigo}/>,
        },
        {
            path: "/cadastro",
            element: <PerfilForm depoisDeFinalizar={voltar} aoCancelar={voltar} />
        },
        {
            path: "/editar",
            element: (
                (() => {
                    const idParam = searchParams.get("id");
                    const id = Number(idParam);
                    if (isNaN(id) || id <= 0) {
                        return <Navigate to={"."} />;
                    }

                    return <PerfilForm codigo={id} depoisDeFinalizar={voltar} aoCancelar={voltar} />
                })()
            )
        },
        {
            path: "*",
            element: <Navigate to="." />
        }
    ])

    return (
        <React.Fragment>
            {routes}
        </React.Fragment>
    );


}